// extracted by mini-css-extract-plugin
var _1 = "styles-module__photosGallery___yNOYw";
var _2 = "styles-module__photosGrid___zByZM";
var _3 = "styles-module__showMoreContainer___LPTBW";
export { _1 as "photosGallery", _2 as "photosGrid", _3 as "showMoreContainer" }
